import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { type FormControl, type FormGroup, ReactiveFormsModule } from '@angular/forms';

import type { RespondFormWrapperConfig } from '@core/ask-hr-dynamic-forms-types';
import { formSignalValue } from '@core/common-legacy';
import { CheckboxComponent } from '@core/user-interface-legacy';

import { RespondFormWrapperComponent } from '../../partials/respond-form-wrapper/respond-form-wrapper.component';

export type InputSelectManyConfig = RespondFormWrapperConfig & {
  options: Array<{
    value: string;
  }>;
};

@Component({
  selector: 'input-checkbox-respond',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RespondFormWrapperComponent, ReactiveFormsModule, CheckboxComponent],
  template: `
    <respond-form-wrapper [answerConfig]="respondConfig()">
      @for (option of respondConfig().options; track option.value) {
        <rt-checkbox
          [value]="option.value"
          [checked]="checkedValues()[option.value]"
          [disabled]="!!respondConfig().disabled"
          (valueChange)="toggleValue(option.value)"
          [attr.margin-bottom-small]="!$last ? '' : null"
        >
          {{ option.value }}
        </rt-checkbox>
      }
    </respond-form-wrapper>
  `,
})
export class RespondSelectManyComponent {
  public respondConfig = input.required<InputSelectManyConfig>();
  public respondForm = input.required<
    FormGroup<{
      value: FormControl<string[]>;
    }>
  >();

  protected formValue = formSignalValue(this.respondForm);
  protected checkedValues = computed(
    (): Record<string, boolean> =>
      Object.fromEntries(this.formValue().value.map(value => [value, true])),
  );

  protected toggleValue(value: string): void {
    const currentValues = this.formValue().value;
    const newValues = currentValues.includes(value)
      ? currentValues.filter(v => v !== value)
      : [...currentValues, value];

    this.respondForm().controls.value.setValue(newValues);
  }
}
